import { render, staticRenderFns } from "./MakeVideo.vue?vue&type=template&id=266265a8&"
import script from "./MakeVideo.vue?vue&type=script&lang=js&"
export * from "./MakeVideo.vue?vue&type=script&lang=js&"
import style0 from "./MakeVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports